import { Check } from "lucide-react";
import { FILTER_GROUPS } from "../../lib/filters";

// Reusable filter body — used in the desktop sidebar and the mobile drawer.
// Facet counts come from the API response's `facets`, not client computation.
export const FilterPanel = ({ facets, filters, onToggle }) => {
  const countFor = (groupId, value) => {
    const entrants = facets?.[groupId];
    const match = entrants && entrants.find((e) => e.value === value);
    return match ? match.count : 0;
  };

  return (
    <div data-testid="filter-panel" className="space-y-9">
      {FILTER_GROUPS.map((group) => (
        <fieldset key={group.id} data-testid={`filter-group-${group.id}`}>
          <legend className="eyebrow text-taupe mb-4">{group.label}</legend>
          <div className="space-y-1">
            {group.options.map((opt) => {
              const active = filters[group.id].includes(opt);
              const count = countFor(group.id, opt);
              const dim = count === 0 && !active;
              return (
                <button
                  key={opt}
                  type="button"
                  onClick={() => onToggle(group.id, opt)}
                  data-testid={`filter-${group.id}-${opt.replace(/[^a-zA-Z0-9]/g, "")}`}
                  aria-pressed={active}
                  className={`w-full flex items-center gap-3 py-2 text-left transition-opacity duration-200 hover:opacity-70 ${
                    dim ? "opacity-45" : ""
                  }`}
                >
                  <span
                    className={`grid place-items-center h-[18px] w-[18px] rounded-[4px] border transition-colors duration-200 shrink-0 ${
                      active ? "bg-charcoal border-charcoal" : "border-taupe/60 bg-transparent"
                    }`}
                  >
                    {active && <Check size={12} strokeWidth={2.5} className="text-ivory" />}
                  </span>
                  <span
                    className={`text-sm flex-1 ${active ? "text-charcoal font-medium" : "text-charcoal/75"}`}
                  >
                    {opt}
                  </span>
                  <span className="text-xs text-taupe tabular-nums">{count}</span>
                </button>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
};